import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'found';
import { Dropdown, Grid, Icon } from 'semantic-ui-react';
import { SelectableBlock } from '../../Elements';
import currencyFormatter from 'currency-formatter';
import styles from '../Financial.scss';

class InvoicesComponent extends Component {

  static propTypes = {
    children: PropTypes.node.isRequired,
    location: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);
    this.toggleStatus = this.toggleStatus.bind(this);
    this.handleStatusFilterChange = this.handleStatusFilterChange.bind(this);
    this.setQuery = this.setQuery.bind(this);
  }

  setQuery(key, value) {
    const { pathname, query } = _.cloneDeep(this.props.location);
    query[key] = value;
    this.props.router.replace({ pathname, query });
  }

  handleStatusFilterChange(e, selection) {
    this.setQuery('status', selection.value);
  }

  toggleStatus(e, status) {
    const updatedStatus =
      this.props.location.query.status === status ? 'ALL' : status;
    this.setQuery('status', updatedStatus);
  }

  render() {
    const { query } = this.props.location;
    const currency = 'USD';
    const { viewer } = this.props;

    const statusOptions = [
      { text: 'All Invoices', value: 'ALL' },
      { text: 'Outstanding Invoices', value: 'OUTSTANDING' },
      { text: 'Paid Invoices', value: 'PAID' },
      { text: 'Past Due Invoices', value: 'PAST_DUE' }
    ];
    const statusMappings = {
      ALL: 'All Invoices',
      OUTSTANDING: 'Outstanding Invoices',
      PAID: 'Paid Invoices',
      PAST_DUE: 'Past Due Invoices'
    };

    return (
      <Grid stackable>
        <Grid.Row>
          <Grid.Column width={8}>
            <Grid>
              <Grid.Row columns='equal'>
                <Grid.Column>
                  <SelectableBlock
                    onChange={e => this.toggleStatus(e, 'OUTSTANDING')}
                    checked={query.status === 'OUTSTANDING'}
                    className={styles.statusBlock}
                    color='grey'
                  >
                    <h3>Outstanding Payments</h3>
                    <p className={styles.statusBlockAmount}>
                      {currencyFormatter.format(
                        viewer.outstanding_payments_cents / 100,
                        { code: currency }
                      )}
                    </p>
                  </SelectableBlock>
                </Grid.Column>
                <Grid.Column>
                  <SelectableBlock
                    onChange={e => this.toggleStatus(e, 'PAST_DUE')}
                    checked={query.status === 'PAST_DUE'}
                    className={styles.statusBlock}
                    color='grey'
                  >
                    <h3>Past Due Payments</h3>
                    <p
                      className={[
                        styles.statusBlockAmount,
                        viewer.past_due_payments_cents > 0 ? styles.red : null
                      ].join(' ')}
                    >
                      {currencyFormatter.format(
                        viewer.past_due_payments_cents / 100,
                        { code: currency }
                      )}
                    </p>
                  </SelectableBlock>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
          <Grid.Column width={8} />
        </Grid.Row>
        <Grid.Row columns='equal' only='computer tablet'>
          <Grid.Column>
            <Dropdown
              button
              basic
              floating
              trigger={<span><Icon name='filter' /> {statusMappings[query.status] || 'All Invoices'}</span>}
              onChange={this.handleStatusFilterChange}
              options={statusOptions}
              value={query.status || 'ALL'}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns='equal' only='mobile'>
          <Grid.Column>
            <Dropdown
              button
              basic
              fluid
              floating
              trigger={<span><Icon name='filter' /> {statusMappings[query.status] || 'All Invoices'}</span>}
              onChange={this.handleStatusFilterChange}
              options={statusOptions}
              value={query.status || 'ALL'}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={16}>
            {this.props.children}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

}

export default withRouter(InvoicesComponent);



// WEBPACK FOOTER //
// ./webpack/components/Financial/Invoices/InvoicesComponent.js